import { CalcV100State } from 'src/modules/user-input/calcV100/types.ts';
import { water } from 'src/modules/user-input/calcV100/constants.ts';
import { Units } from 'uom-units';

export const initialState: CalcV100State = {
    density: water.density,
    heatCapacity: water.heatCapacity,
    ratedCapacity: '',
    ratedCapacityUnit: Units.KiloWatt,
    temperatureDifference: '',
    temperatureDifferenceUnit: Units.Kelvin,
    temperatureDifferenceAir: '',
    temperatureDifferenceAirUnit: Units.Kelvin,
    airflowVolume: '',
    airflowVolumeUnit: Units.CubicFeetPerMinute,
};
